import { localeFromPath, localizeHref } from '$lib/localization/locale';
import { goto } from '$app/navigation';

/** Used by account-required pages when authentication resolves to signed out. */
export function redirectToLogin(): Promise<void> {
	try {
		localStorage.setItem(
			'redirectUrl',
			window.location.pathname + window.location.search + window.location.hash
		);
	} catch {
		// Blocked storage must not leave an account-required page open.
	}
	return goto(localizeHref(localeFromPath(window.location.pathname), '/login'), {
		replaceState: true
	});
}
